import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Checkbox, ListItemAvatar } from '@mui/material';
import { memo } from 'react';
import { ListItemText } from '../ListItemText.js';
import { SettingsListItemButton } from '../SettingsListItemButton.js';
export const ToolItem = memo(({ tool, typeKey, isEnabled, onToggle }) => {
    const handleClick = () => {
        onToggle(tool.key);
    };
    const handleCheckboxClick = (e) => {
        e.stopPropagation();
        onToggle(tool.key);
    };
    return (_jsxs(SettingsListItemButton, { onClick: handleClick, children: [_jsx(ListItemAvatar, { children: _jsx(Avatar, { src: tool.logoURI, alt: tool.name, children: tool.name[0] }) }), _jsx(ListItemText, { primary: tool.name }), _jsx(Checkbox, { id: `${typeKey}-${tool.key}-checkbox`, checked: isEnabled, onChange: handleClick, onClick: handleCheckboxClick, sx: { mr: -1 } })] }));
});
//# sourceMappingURL=ToolItem.js.map